
import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import FormWrapper from "@/components/FormWrapper.vue";
import { TakipEntity } from "@/entity/TakipEntity";
import TakipTalebiTaslak from "@/components/TakipTalebiTaslak.vue";
import Emirler from "@/components/Emirler.vue";
import IcraTakipKartiTaslak from "@/components/IcraTakipKartiTaslak.vue";
import JSZip from "jszip";
import { Udf } from "@/classes/HtmlToUdf";
import * as FileSaver from "file-saver";
import OdemeTaahhuduTaslak from "@/components/OdemeTaahhuduTaslak.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import KartOzelindeHesapAyarForm from "@/components/forms/KartOzelindeHesapAyarForm.vue";

@Component({
  components: {
    KartOzelindeHesapAyarForm, FormDialog,
    OdemeTaahhuduTaslak,
    IcraTakipKartiTaslak,
    Emirler,
    TakipTalebiTaslak,
    FormWrapper,
  },
})
export default class OnizleForm extends Vue {
  @Prop() takip!: TakipEntity;
  @Ref("takipTalebiTaslak") readonly takipTalebiTaslak!: TakipTalebiTaslak;
  @Ref("icraTakipKartiTaslak")
  readonly icraTakipKartiTaslak!: IcraTakipKartiTaslak;
  @Ref("odemeTaahhuduTaslak")
  readonly odemeTaahhuduTaslak!: OdemeTaahhuduTaslak;
  @Ref("emirlerTaslak") readonly emirlerTaslak!: Emirler;

  tab = 0;
  isKartNoVisible: boolean = true;

  udfDialog: boolean = false;
  udfPreviewHtml: string = "";
  udfPreviewLoading: boolean = false;

  // Aktif sekmeye karşılık gelen yazdırılabilir component id'si
  get activeComponentId(): string {
    if (this.tab == 1) return "emirler";
    if (this.tab == 2) return "icraTakipKartiTaslak";
    if (this.tab == 3) return "odemeTaahhuduTaslak";
    return "takipTalebi";
  }

  // UDF İndir'e tıklanınca önizleme dialog'unu aç ve önizlemeyi üret
  openUdfPreview() {
    this.udfDialog = true;
    this.udfPreviewLoading = true;
    this.udfPreviewHtml = "";
    // Dialog DOM'a girsin, ağır render'ı bir tick sonraya al (UI bloklanmasın)
    this.$nextTick(() => {
      setTimeout(() => {
        try {
          this.udfPreviewHtml = this.$helper.getUdfPreviewHtml(this.activeComponentId);
        } catch (e) {
          this.udfPreviewHtml = "<p>Önizleme oluşturulamadı.</p>";
        } finally {
          this.udfPreviewLoading = false;
        }
      }, 0);
    });
  }

  print() {
    const printHeader = document.querySelector(".print-header")as HTMLElement | null;;
    const printFooter = document.querySelector(".print-footer")as HTMLElement | null;
    if (printHeader) {
      printHeader.style.display = "none";
    }
    if (printFooter) {
      printFooter.style.display = "none";
    }

    if (this.tab == 0) {
      this.takipTalebiTaslak.print();
    } else if (this.tab == 1) {
      this.emirlerTaslak.print();
    } else if (this.tab == 2) {
      this.icraTakipKartiTaslak.print();
    } else if (this.tab == 3) {
      this.odemeTaahhuduTaslak.print();
    }
  }

  load(){
    this.$emit('load')
  }

  imzasizUdfIndir(){

    if (this.tab == 0) {
      this.takipTalebiTaslak.imzasizUdfIndir();
    } else if (this.tab == 1) {
      this.emirlerTaslak.imzasizUdfIndir();
    } else if (this.tab == 2) {
      this.icraTakipKartiTaslak.imzasizUdfIndir();
    } else if (this.tab == 3) {
      this.odemeTaahhuduTaslak.imzasizUdfIndir();
    }

    this.udfDialog = false;
  }
  imzaliUdfIndir(){
    if (this.tab == 0) {
      this.takipTalebiTaslak.imzaliUdfIndir();
    } else if (this.tab == 1) {
      this.emirlerTaslak.imzaliUdfIndir();
    } else if (this.tab == 2) {
      this.icraTakipKartiTaslak.imzaliUdfIndir();
    } else if (this.tab == 3) {
      this.odemeTaahhuduTaslak.imzaliUdfIndir();
    }

    this.udfDialog = false;
  }

  wordYazdir() {
    let belge: string = "";
    if (this.tab == 0) {
      belge = "takipTalebi";
    } else if (this.tab == 1) {
      belge = "emirler";
    } else if (this.tab == 2) {
      belge = "icraTakipKartiTaslak";
    } else if (this.tab == 3) {
      belge = "odemeTaahhuduTaslak";
    }



    var header =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
      "xmlns:w='urn:schemas-microsoft-com:office:word' " +
      "xmlns='http://www.w3.org/TR/REC-html40'>" +
      "<head><meta charset='utf-8'></head><body>";
    var footer = "</body></html>";
    var sourceHTML = header + (document.getElementById(belge)?.innerHTML) + footer;
    var source =
      "data:application/vnd.ms-word;charset=utf-8," +
      encodeURIComponent(sourceHTML);
    var fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = belge + ".doc";
    fileDownload.click();
    document.body.removeChild(fileDownload);
  }
}
